import { Link } from 'react-router-dom';
import { Lock, Smartphone, Briefcase } from 'lucide-react';
import { HomlyLogo } from '../../components/brand/HomlyLogo';
import { MobileAppBadges } from './MobileAppBadges';

export function Footer() {
    return (
        <footer className="bg-[#0a0a1a] text-white py-20">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid md:grid-cols-4 gap-12 mb-16">
                    <div>
                        <HomlyLogo size="lg" />
                        <p className="text-white/50 mt-4 text-sm">
                            La plateforme de gestion des mandats immobiliers nouvelle génération.
                        </p>
                        <div className="mt-6">
                            <p className="text-xs text-white/40 mb-3">Disponible sur mobile</p>
                            <MobileAppBadges />
                        </div>
                    </div>
                    <div>
                        <h4 className="font-bold mb-4">Produit</h4>
                        <ul className="space-y-3 text-sm text-white/50">
                            <li><a href="#" className="hover:text-white transition-colors">Fonctionnalités</a></li>
                            <li><a href="#pricing" className="hover:text-white transition-colors">Tarifs</a></li>
                            <li><Link to="/reseau" className="hover:text-white transition-colors">Réseau Homly</Link></li>
                            <li><Link to="/pro" className="hover:text-white transition-colors">Homly Partenaires (Artisans)</Link></li>
                            <li><Link to="/login" className="hover:text-white transition-colors">Connexion</Link></li>
                        </ul>
                    </div>
                    <div>
                        <h4 className="font-bold mb-4">Ressources</h4>
                        <ul className="space-y-3 text-sm text-white/50">
                            <li><Link to="/diagnostic-agence" className="hover:text-white transition-colors flex items-center gap-1.5"><span className="inline-block w-1.5 h-1.5 rounded-full bg-[#FF914D] animate-pulse" />Diagnostic gratuit (2 min)</Link></li>
                            <li><Link to="/roadmap" className="hover:text-white transition-colors">Roadmap produit</Link></li>
                            <li><a href="#faq" className="hover:text-white transition-colors">FAQ</a></li>
                            <li><a href="#" className="hover:text-white transition-colors">Blog</a></li>
                            <li><a href="#" className="hover:text-white transition-colors">Support</a></li>
                        </ul>
                    </div>
                    <div>
                        <h4 className="font-bold mb-4">Légal</h4>
                        <ul className="space-y-3 text-sm text-white/50">
                            <li><Link to="/cgu" className="hover:text-white transition-colors">CGU</Link></li>
                            <li><Link to="/privacy" className="hover:text-white transition-colors">Confidentialité</Link></li>
                            <li><Link to="/mentions-legales" className="hover:text-white transition-colors">Mentions légales</Link></li>
                        </ul>
                    </div>
                </div>

                <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
                    <p className="text-sm text-white/30">© 2025 Homly. Tous droits réservés.</p>
                    <div className="flex items-center gap-6">
                        <div className="flex items-center gap-2 text-sm text-white/30">
                            <Lock className="w-4 h-4" /><span>Chiffrement AES-256 · RGPD</span>
                        </div>
                        <div className="flex items-center gap-2 text-sm text-white/30">
                            <Smartphone className="w-4 h-4" /><span>iOS & Android</span>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}
